import React from 'react';
import styles from './Resizer.module.css';

interface PixelSizeProps {
  width: number;
  height: number;
}

const PixelSize: React.FC<PixelSizeProps> = ({ width, height }) => {
  return (
    <span className={styles.pixelSize}>
      <span className={styles.width}>{Math.round(width)}</span>
      <span className={styles.height}>{Math.round(height)}</span>
    </span>
  );
};

export default PixelSize;
